export const Constants = {
  api_url: "https://api-brightbeep.brightedumont.com",
  // api_url: "http://192.168.1.106:8000",
};
